import { pwa } from 'white-labelling/pwa';

export default pwa;
